module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAAACXBIWXMAAAsSAAALEgHS3X78AAAApUlEQVQ4y+WT0Q3DIAxEn6MOwggZIaNklI7CCB2hI3QERiATXH5MhaKAEom/WLIMuvNhTmCAGBQvAEkGYGYq6ytR881MUwVEYLs5zOZ9/5BnBmZJlARm4OP4t4HnSgPVhAM5VUQBqcNtiwGLE35A8CpgaYlNHT+S1+DCwfe5Z2LPs3i4ZrzkmTfmk/FX4A2sJ1guBwAyFxvyzmzkDzAfcYzYMybbASSB0tKgqEP+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Money.png
// module id = 182
// module chunks = 0 1